import { Injectable } from '@angular/core';
import { MapsAPILoader } from '@agm/core';
import { filter, catchError, tap, map, switchMap } from 'rxjs/operators';
import { from, Observable, of, throwError, merge } from 'rxjs';


declare let google: any;

@Injectable({ providedIn: 'root' })
export class GeocodeService {
  private geocoder: any;

  private address: string;

  constructor(private mapLoader: MapsAPILoader) { }

  private initGeocoder() {
    // console.log('Init geocoder!');
    this.geocoder = new google.maps.Geocoder();
  }

  private waitForMapsToLoad(): Observable<boolean> {
    if (!this.geocoder) {
      return from(this.mapLoader.load())
        .pipe(
          tap(() => this.initGeocoder()),
          map(() => true)
        );
    }
    return of(true);
  }

  geocodeAddress(lat, lng): Observable<any> {
    // console.log('Start reverse geocoding!');
    return this.waitForMapsToLoad().pipe(
      // filter(loaded => loaded),
      switchMap(() => {
        return Observable.create(observer => {
          this.geocoder.geocode({ 'location': { lat: parseFloat(lat), lng: parseFloat(lng) } }, (results, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              // console.log('Reverse Geocoding complete!');
              observer.next({
                address: results[0].formatted_address
              });
            } else {
              // console.log('Error - ', results, ' & Status - ', status);
              observer.next({
                address: 'N/A address'
              })
            }
            observer.complete();
          });
        })
      }),
      catchError(e => { throw new Error(e) })
    )
  }
}
